import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/shared/message/message.service';
import { TitleService } from 'src/app/shared/title.service';
import { UserService } from 'src/app/user/user.service';

type PaneType = 'left' | 'right';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  standalone: false
})
export class SignUpComponent implements OnInit {
  private titleService = inject(TitleService);
  private user = inject(UserService);
  private router = inject(Router);
  private messageService = inject(MessageService);

  activePane: PaneType = 'left';

  userData: string[];
  isLoading = false;
  error = null;

  onSubmit(event: string[]) {
    this.userData = event;
    this.signUp();
  }

  isLoadingEvent(event: boolean) {
    this.isLoading = event;
  }

  errorEvent(event: string) {
    this.error = event;
  }

  ngOnInit() {
    this.titleService.setTitle('Sign Up');
  }

  signUp() {
    this.isLoading = true;
    const [username, email, password] = this.userData;
    this.user.register(username, email, password).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigate(['']);
        this.messageService.message = 'การลงทะเบียนสำเร็จแล้ว กรุณาตรวจสอบอีเมลเพื่อยืนยันผู้ใช้';
      },
      error: () => {
        this.isLoading = false;
        this.errorEvent('ข้อมูลผิดพลาด ตรวจสอบข้อมูลใหม่อีกครั้ง');
      }
    });
  }
}
